<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, 
           
            <a
              href="https://smartevoec.com"
              class="font-weight-bold"
              target="_blank"
              >Smart-Evo</a
            >
            Todos los derechos reservados.
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://www.facebook.com/smartevo.info"
                class="nav-link text-muted"
                target="_blank"
                >Facebook</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://www.instagram.com/smartevo.info/"
                class="nav-link text-muted"
                target="_blank"
                >Instagram</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://www.tiktok.com/@smartevo.info"
                class="nav-link text-muted"
                target="_blank"
                >Tiktok</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://store.smartevoec.com/"
                class="nav-link pe-0 text-muted"
                target="_blank"
                >Tienda</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
